import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  InputDiv,
  Label,
  Input,
  SearchOptions,
  Option,
} from './formSelectStyle';
import vector from '../../../../assets/equipment/vector.svg';

const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SelectTrigger = styled(Input)`
  cursor: pointer;
  padding-right: 2.5rem;
  caret-color: transparent;
`;

const VectorIcon = styled.img`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  pointer-events: none;
`;

export interface FormOptionSelectOption {
  value: number;
  label: string;
}

interface FormOptionSelectProps {
  label: string;
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  options: readonly FormOptionSelectOption[];
  placeholder?: string;
  allowEmpty?: boolean;
  hasError?: boolean;
}

const FormOptionSelect: React.FC<FormOptionSelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder = 'Selecione',
  allowEmpty = true,
  hasError = false,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const selectedLabel =
    value === null || value === undefined
      ? ''
      : options.find((option) => option.value === value)?.label ?? '';

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (optionValue: number | null) => {
    onChange(optionValue);
    setShowOptions(false);
  };

  return (
    <InputDiv ref={containerRef}>
      <Label>{label}</Label>
      <SelectWrapper>
        <SelectTrigger
          readOnly
          placeholder={placeholder}
          value={selectedLabel}
          onClick={() => setShowOptions((prev) => !prev)}
          onFocus={() => setShowOptions(true)}
          $hasError={hasError}
        />
        <VectorIcon src={vector} alt="" />
      </SelectWrapper>
      {showOptions && (
        <SearchOptions>
          {allowEmpty && (
            <Option
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => handleSelect(null)}
              isSelected={value === null || value === undefined}
            >
              {placeholder}
            </Option>
          )}
          {options.map((option) => (
            <Option
              key={option.value}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => handleSelect(option.value)}
              isSelected={value === option.value}
            >
              {option.label}
            </Option>
          ))}
        </SearchOptions>
      )}
    </InputDiv>
  );
};

export default FormOptionSelect;
